// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1ClaimAccumulatorSearchAccumulatorSearchResponse {
    static getAttributeTypeMap() {
        return ClaimV1ClaimAccumulatorSearchAccumulatorSearchResponse.attributeTypeMap;
    }
}
ClaimV1ClaimAccumulatorSearchAccumulatorSearchResponse.discriminator = undefined;
ClaimV1ClaimAccumulatorSearchAccumulatorSearchResponse.additionalProperties = false;
ClaimV1ClaimAccumulatorSearchAccumulatorSearchResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=claimV1ClaimAccumulatorSearchAccumulatorSearchResponse.js.map